import axios from '../axios/redditlikeApi'

const getUsers = () => axios.get('/users')

const updateUserById = reqBody => axios.patch('/users', reqBody)

const getUserById = userId => axios.get(`/users/${userId}`)

const verifyPassword = reqBody => axios.post('/users/verify-password', reqBody)

const updatePassword = reqBody => axios.patch('/users/update-password', reqBody)

export default {
  getUsers,
  updateUserById,
  getUserById,
  verifyPassword,
  updatePassword
}
